import {
    sppcolorimage,
    euroaccidentcolor,
    Revolt,
    bankidcolor,
    trygggcolor,
    microsoftcolor,
    TrygggGray,
    SPPGray,
    BankIdGray,
    RevoltGray,
    EuroGray,
    MicrosoftGray,
} from './images/svg/icons';

import '../scss/partner-logo.style.scss';
import { Col, Container, Row } from 'react-bootstrap';
import React from 'react';

const Coloredlogo = [
    { id: 1, src: sppcolorimage, alt: 'POSLOGO' },
    { id: 2, src: Revolt, alt: 'Revolt' },
    { id: 3, src: microsoftcolor, alt: 'Microsoft' },
    { id: 4, src: euroaccidentcolor, alt: 'EuroAccident' },
    { id: 5, src: bankidcolor, alt: 'BankId' },
    { id: 6, src: trygggcolor, alt: 'Tryggg' },
];

const graylogo = [
    { id: 1, src: SPPGray, alt: 'POSLOGO' },
    { id: 2, src: RevoltGray, alt: 'Revolt' },
    { id: 3, src: MicrosoftGray, alt: 'Microsoft' },
    { id: 4, src: EuroGray, alt: 'EuroAccident' },
    { id: 5, src: BankIdGray, alt: 'BankId' },
    { id: 6, src: TrygggGray, alt: 'Tryggg' },
];

export const PartnerLogo = () => {
    const [activeId, setActiveId] = React.useState<number | null>(null);

    const handleMouseHover = (id: number | null) => {
        setActiveId(id);
    };

    return (
        <Container className='partner-logo-container'>
            <Row className='d-flex justify-content-between align-items-between flex-wrap gap-partner partner-logo-row'>
                    {graylogo.map((gray, index) => {
                        const colored = Coloredlogo.find((c) => c.id === gray.id);
                        const isHovered = activeId === gray.id;
                        return (
                            <div key={gray.id} className="d-flex align-items-center justify-content-center ">
                                <img
                                    src={isHovered && colored ? colored.src : gray.src}
                                    alt={gray.alt}
                                    className='partner-logo-img on-hover-scale'
                                    loading="lazy"
                                    draggable="false"
                                    onMouseEnter={() => handleMouseHover(gray.id)}
                                    onMouseLeave={() => handleMouseHover(null)}
                                />
                            </div>
                        );
                    })}
            </Row>
        </Container>
    );
};
